// components/ExpiryPopup/ExpiryPopup.js
import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Popup = styled.div`
  background: #ffffff;
  width: 400px;
  max-width: 90%;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
`;

const Title = styled.h3`
  margin-bottom: 10px;
  color: #ff4d4f;
`;

const Text = styled.p`
  font-size: 14px;
  color: #333;
`;

const CloseBtn = styled.button`
  margin-top: 15px;
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background: #0095ff;
  color: #fff;
  cursor: pointer;
`;

const ExpiryPopup = ({ daysLeft, onClose }) => {
  return (
    <Overlay>
      <Popup>
        <Title>Package Expiring Soon ⚠️</Title>
        <Text>
          Your package will expire in <strong>{daysLeft}</strong> day
          {daysLeft > 1 ? 's' : ''}.  
          Please renew to avoid service interruption.
        </Text>
        <CloseBtn onClick={onClose}>Close</CloseBtn>
      </Popup>
    </Overlay>
  );
};

export default ExpiryPopup;
